<template>
    <div v-if="journalHistory" class="journal_his">
        <component :is="'VuePerfectScrollbar'" ref="historyScroll" class="scroll-area-content-h" :settings="settings" :key="$vs.rtl">
            <!-- Сообщение о пустом журнале -->
            <vs-alert v-if="emptyHistory" active="true">
                {{$t('no_data_text')}}
            </vs-alert>

            <!-- Таблица -->
            <vs-table v-else stripe :data="journalHistory.results" class="t_height">
                <template slot="thead">
                    <vs-th>{{$t('date_and_time')}}</vs-th>
                    <vs-th>{{$t('name_of_student')}}</vs-th>
                    <vs-th>{{$t('act')}}</vs-th>
                    <vs-th>{{$t('exercise')}}</vs-th>
                    <vs-th>{{$t('full_name_user')}}</vs-th>
                    <vs-th>{{$t('old_evaluation')}}</vs-th>
                    <vs-th>{{$t('new_evaluation')}}</vs-th>
                    <vs-th>{{$t('skip')}}</vs-th>
                    <vs-th>{{$t('Old_Topic_Title')}}</vs-th>
                    <vs-th>{{$t('New_Topic_Title')}}</vs-th>
<!--                    <vs-th>{{$t('blocking-ej')}}</vs-th>-->
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td style="text-align: center;">
                            {{ dateReplace(data[indextr].created, true) }}
                        </vs-td>
                        <vs-td>
                            {{ data[indextr].student_fio }}
                        </vs-td>
                        <vs-td style="text-align: center;">
<!--                            <span :class="`text-${ actionReplaceColor(data[indextr].action_type) }`">-->
<!--                                {{ actionReplace(data[indextr].action_type) }}-->
<!--                            </span>-->
                            <span >
                                 {{ data[indextr].ej_blocking ? ejBlockingText(data[indextr].ej_blocking)  : actionReplace(data[indextr].action_type)   }}
                            </span>
                        </vs-td>
                        <vs-td style="text-align: center;">
                            <div v-if="data[indextr].lesson_date">
                                {{ dateReplace(data[indextr].lesson_date) }}<br>
                                {{ data[indextr].from_time.slice(0,5) }}-{{ data[indextr].to_time.slice(0,5) }}
                            </div>
                            <div v-else>
                                -
                            </div>

                        </vs-td>
                        <vs-td>
                            {{ data[indextr].changer_fio }}
                        </vs-td>
                        <vs-td>
                            {{ data[indextr].old_estimate }}
                        </vs-td>
                        <vs-td>
                            {{ data[indextr].new_estimate }}
                        </vs-td>
                        <vs-td>
                            <div v-if="(data[indextr].action_type==10)||(data[indextr].action_type==12)">
                                {{ $t('skip') }}
                            </div>
                            <div v-else-if="data[indextr].action_type==11">
                                {{ $t('skipping_for_a_reason',{text:data[indextr].pass_mark_text}) }}
                            </div>
                            <div v-else-if="data[indextr].action_type==13">
                                {{ $t('the_pass_was_removed') }}
                            </div>
                            <div v-else-if="data[indextr].action_type==14">
                                {{ $t('cancelled_due_to',{text:data[indextr].pass_mark_text}) }}
                            </div>
                        </vs-td>
                        <vs-td>
                            <span v-html="data[indextr].old_topic_name">
                            </span>
                        </vs-td>
                        <vs-td>
                            <span v-html="data[indextr].new_topic_name">
                            </span>
                        </vs-td>
<!--                        <vs-td>-->
<!--                            {{ $t(data[indextr].ej_blocking) }}-->
<!--                        </vs-td>-->
                    </vs-tr>
                </template>
            </vs-table>
        </component>
        <!-- Пагинация -->
        <div v-if="journalHistory.count > 20" class="mt-3 important_pagination">
            <vs-pagination :description="true" class="w-full" :total="Math.ceil(journalHistory.count / 20)" :max="6" v-model="currentPage"></vs-pagination>
        </div>
    </div>
</template>

<script>
import e_journal from '@/store/modules/e_journal.js'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapActions,mapGetters,mapMutations } from 'vuex'
import { actionReplace, actionReplaceColor, ejBlockingText } from "@/pages/Home/EJournal/utils";

export default {
    params: {
        uidtest: {}
    },
    components: {
        VuePerfectScrollbar
    },
    data() {
        return {
            currentPage: 1,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.50
            }
        }
    },
    watch: {
        // uid(){
        //     if(this.uid){
        //         console.log(this.uid)
        //         this.$store.dispatch('e_journal/fetchJournalHistory', {id: this.uid})
        //     }
        // },
        currentPage(val) {
            // При смене страницы делаем запрос
            this.changePage(val)
        },
        uidtest(){
            this.$store.dispatch('e_journal/fetchJournalHistory', {id: this.uidtest})
        }
    },
    computed: {
        ...mapGetters({
            GET_history_uid:'e_journal/GET_history_uid'
        }),
        journalHistory() {
            // Информация об истории
            // if(this.$store.state.e_journal){
            if (this.uidtest){
                this.$store.dispatch('e_journal/fetchJournalHistory', {id: this.uidtest})
            }
            return this.$store.state.e_journal.journalHistory
            // }

        },
        emptyHistory() {
            // Проверка на пустоту истории
            return this.$store.state.e_journal.emptyHistory
        }
    },
    async created() {
        if(!this.$store.hasModule('e_journal')){
            await this.$store.registerModule('e_journal', e_journal)
        }
        // console.log(this.uid)
        // if (this.uid){
        //
        //     this.$store.dispatch('e_journal/fetchJournalHistory', {id: this.uid})
        // }

    },
    methods: {
        actionReplace,
        actionReplaceColor,
        ejBlockingText,
        async changePage(page) {
            // Запрашиваем историю изменения для текущей страницы
            try {
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: '.journal_his',
                        scale: 0.6
                    })
                })
                // console.log(this.GET_history_uid)
                await this.$store.dispatch('e_journal/fetchJournalHistory', {id: this.GET_history_uid, page })
            } catch(e) {

            } finally {
                // Пролистываем скролл наверъ
                this.$refs.historyScroll.$el.scrollTop = 0
                this.$vs.loading.close('.journal_his > .con-vs-loading')
            }
        },
        dateReplace(date, time = false) {
            // Переписываем дату
            return this.$moment(date).format(`DD.MM.YYYY ${ time ? 'HH:mm' : '' }`)
        },
    }
}
</script>

<style lang="scss">
.t_height{
    max-height:  48em;
    overflow: auto;
}
.vs-con-tbody, vs-table--tbody, .vs-table--content{
    // Раньше бегунок прокрутки влева-вправо был доступен, когда спускаются в самый вниз таблицы.
    // Опция ниже нужна, чтобы бегунок был доступен независимо от степени прокрутки вниз.
    // Суть в том, чтобы сделать все child элементы overflow: visible;.
    // visible - Content is not clipped and may be rendered outside the padding box.
    // После установки "overflow: visible;" для child, у parent должна быть установлена "overflow: auto;"
    // overflow - https://developer.mozilla.org/en-US/docs/Web/CSS/overflow
    overflow: visible !important;
}
.journal_his{
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
    .important_pagination{
        .vs-col{
            &:first-child{
                div{
                    display: none;
                }
            }
        }
    }
}
//.scroll-area-content-h{
//    height: calc(var(--vh, 1vh)*100 - 33rem);
//}
@media only screen and (max-width: 900px) {
    .journal_loader{
        .scroll-area-content-h{
            height: calc(var(--vh, 1vh)*100 - 48rem);
        }
    }
}
</style>
